import React from "react";
import { useAppSelector } from "../../../redux";
import loaderGif from "../../../assets/loader/AksharArt_loader.gif";
import "./GlobalLoader.css";

const GlobalLoader: React.FC = () => {
  const isAuthLoading = useAppSelector((state) => state.auth.isLoading);
  const isStudentLoading = useAppSelector((state) => state.student.isLoading);
  const activeRequests = useAppSelector((state) => state.loading.activeRequests);

  const isLoading = activeRequests > 0 || isAuthLoading || isStudentLoading;

  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="global-loader-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Loading"
    >
      <svg
        width="0"
        height="0"
        style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
        aria-hidden="true"
      >
        <filter id="remove-black-bg" colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="
              1 0 0 0 0
              0 1 0 0 0
              0 0 1 0 0
              5 5 5 0 0"
          />
        </filter>
      </svg>
      <div className="global-loader-content">
        <img
          src={loaderGif}
          alt="Loading..."
          className="global-loader-gif"
        />
      </div>
    </div>
  );
};

export default GlobalLoader;
